import axios from "axios";
import store from "../store/store";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { RootState } from "../models/RootState";

/*
|--------------------------------------------------------------------------
| Main API
|--------------------------------------------------------------------------
| Sports, odds, markets, providers, etc.
*/
const API = axios.create({
  baseURL: "https://api.mysportsfeed.io/api/v1/core",
  responseType: "json",
  withCredentials: false,
  timeout: 10000,
});

/*
|--------------------------------------------------------------------------
| User API
|--------------------------------------------------------------------------
| User-related APIs:
| - balance
| - user profile
| - bets
| - transactions
| - account
| - authentication
| etc.
*/
const USER_API = axios.create({
  // baseURL: "http://localhost:8000/api",
  baseURL: "https://booking.hemnix.com/api",
  responseType: "json",
  withCredentials: false,
  timeout: 10000,
});

/*
|--------------------------------------------------------------------------
| Main API - Response Interceptor
|--------------------------------------------------------------------------
*/
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("*********** Unauthorized Error - API ***********");

      const token = sessionStorage.getItem("jwt_token");

      // logout logic if required
    }

    return Promise.reject(error);
  }
);

/*
|--------------------------------------------------------------------------
| User API - Request Interceptor
|--------------------------------------------------------------------------
|
| USER_API gets its own token.
|
*/
USER_API.interceptors.request.use(
  (config) => {
    const userToken = sessionStorage.getItem("user_api_token");

    if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
|--------------------------------------------------------------------------
| User API - Response Interceptor
|--------------------------------------------------------------------------
*/
USER_API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log(
        "*********** Unauthorized Error - USER_API ***********"
      );

      // Optional:
      // sessionStorage.removeItem("user_api_token");
      // logout();
    }

    return Promise.reject(error);
  }
);

export { API, USER_API };

export default API;